module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av343-bcdb586a42f3f0e9d1b71c3c5e271bea.jpg";